<script setup lang="ts">
/**
 * CookieBanner - GDPR cookie consent banner
 * Shows at the bottom of the page when user hasn't consented yet
 */
import { useI18n } from 'vue-i18n'
import { useCookieStore } from '@/stores/cookies'

const { t } = useI18n()
const cookieStore = useCookieStore()
</script>

<template>
  <Transition
    enter-active-class="transition-transform duration-300 ease-out"
    enter-from-class="translate-y-full"
    enter-to-class="translate-y-0"
    leave-active-class="transition-transform duration-200 ease-in"
    leave-from-class="translate-y-0"
    leave-to-class="translate-y-full"
  >
    <div
      v-if="cookieStore.isBannerVisible"
      class="fixed bottom-0 left-0 right-0 z-50 bg-charcoal text-white shadow-lg"
    >
      <div class="container-custom py-4 md:py-6">
        <div class="flex flex-col md:flex-row md:items-center gap-4">
          <!-- Text -->
          <div class="flex-1">
            <p class="text-sm md:text-base">
              {{ $t('cookies.banner_text') }}
              <button
                @click="cookieStore.openModal"
                class="underline hover:text-primary-300 transition-colors"
              >
                {{ $t('cookies.configure_cookies') }}
              </button>
              {{ $t('cookies.banner_text_suffix') }}
            </p>
          </div>

          <!-- Buttons -->
          <div class="flex flex-col sm:flex-row gap-2 sm:gap-3 flex-shrink-0">
            <button
              @click="cookieStore.openModal"
              class="px-4 py-2 text-sm font-medium border border-white rounded-lg hover:bg-white hover:text-charcoal transition-colors"
            >
              {{ $t('cookies.configure_cookies') }}
            </button>
            <button
              @click="cookieStore.acceptAll"
              class="px-4 py-2 text-sm font-medium bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors"
            >
              {{ $t('cookies.accept_all') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>
